import { render } from "./TemplateFrameOptionPersonalizeSettings.vue?vue&type=template&id=419f60e0&scoped=true"
import script from "./TemplateFrameOptionPersonalizeSettings.vue?vue&type=script&lang=js"
export * from "./TemplateFrameOptionPersonalizeSettings.vue?vue&type=script&lang=js"

import "./templateFrameOptionDisplays.scss?vue&type=style&index=0&id=419f60e0&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419f60e0"]])

export default __exports__